<template>
    <div v-if="!isLoading" class="body__form" style="min-height: 100vh">
        <div class="container__form">
            <table class="fm-enqueteout" :cellpadding="`0`" :cellspacing="`0`">
                <tbody>
                    <tr v-if="HEADER">
                        <td>
                            <div class="text-center mb-5">
                                <div v-html="HEADER"></div>
                            </div>
                        </td>
                    </tr>
                    <template v-if="isPageTypeB">
                        <tr
                            v-if="[PAGE_TYPES._B[0], PAGE_TYPES._B[4]].includes(typePageShow) && dataPreview.setting_lottery.is_prize_before_the_draw"
                        >
                            <td>
                                <FormBPrizeCode
                                    :inforData="dataPreview"
                                    :settingDesign="dataPreview.setting_designs"
                                    :formInit="formSerialInit"
                                    :formConfig="formSerialConfig"
                                    :conditionPageShow="typePageShow"
                                />
                            </td>
                        </tr>
                        <tr v-if="PAGE_TYPES._B[2] === typePageShow">
                            <td>
                                <FormBSeriaWinning
                                    :inforDataWinning="dataPreview.form_pages[PAGE_TYPES._B[2]]"
                                    :settingDesign="dataPreview.setting_designs"
                                    :formInit="formSerialInit"
                                    :listInforPrize="dataPreview.serial_code_prizes"
                                    :configBlockForm="configBlockForm"
                                    :inforProvince="inforProvince"
                                    :typePageShow="typePageShow"
                                    :indexCommonOption.sync="indexCommonOption"
                                    :settingRequireLabel="settingRequireLabelFormSerial"
                                    :settingConfirmLabel="settingConfirmLabelFormSerial"
                                />
                            </td>
                        </tr>
                        <tr v-if="PAGE_TYPES._B[3] === typePageShow">
                            <td>
                                <FormBSeriaRejection
                                    :inforDataRejection="dataPreview.form_pages[PAGE_TYPES._B[3]]"
                                    :settingDesign="dataPreview.setting_designs"
                                    :formInit="formSerialInit"
                                    :listInforPrize="dataPreview.serial_code_prizes"
                                    :configBlockForm="configBlockForm"
                                    :inforProvince="inforProvince"
                                    :typePageShow="typePageShow"
                                    :indexCommonOption.sync="indexCommonOption"
                                    :settingRequireLabel="settingRequireLabelFormSerial"
                                    :settingConfirmLabel="settingConfirmLabelFormSerial"
                                />
                            </td>
                        </tr>
                    </template>
                    <tr v-if="isPageTypeI && PAGE_TYPES._I[2] !== typePageShow">
                        <td
                            :class="`text-${onHandleGetValueTextAlign(dataPreview.setting_designs.table_settings.answer_text_alignment.horizontal)}`"
                            :style="`padding: ${
                                dataPreview.setting_designs.table_settings?.cell_setting.margin?.value
                                    ? `${dataPreview.setting_designs.table_settings?.cell_setting.margin?.value}${dataPreview.setting_designs.table_settings?.cell_setting.margin?.unit?.value}`
                                    : '30px'
                            }`"
                        >
                            <div
                                v-if="PAGE_TYPES._I[0] == typePageShow"
                                v-html="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.extension.content"
                            ></div>
                            <div
                                v-if="PAGE_TYPES._I[1] == typePageShow"
                                v-html="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.extension.content"
                            ></div>
                        </td>
                    </tr>
                    <tr>
                        <template v-if="isPageTypeA">
                            <td v-if="!isPageComplete">
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockSaved">
                                        <CommonOption
                                            :key="`preview-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_RADIO,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT,
                                                    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                                                    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
                                                    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                                                ].includes(itemBlock.block_type) &&
                                                (statusBlock ? statusBlock[itemBlock.id]?.visible : evaluatedRulesStart[itemBlock.id]?.visible)
                                            "
                                            :index="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :addressInfor="inforAddress"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :pagePreview="true"
                                            @selectProvince="onHandleGetSelectProvince"
                                            @emitChange="handleConditionANDOR"
                                            :disabled="
                                                statusBlock ? statusBlock[itemBlock.id]?.disabled : evaluatedRulesStart[itemBlock.id]?.disabled
                                            "
                                            :settingRequireLabel="settingRequireLabel"
                                        />
                                        <CommonBlockText
                                            :key="`preview-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
                                                    ALL_BLOCK_TYPE.BLOCK_INPUT,
                                                    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                                                    ALL_BLOCK_TYPE.BLOCK_DATE,
                                                    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                                                    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                                                    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                                                    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                                                    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
                                                ].includes(itemBlock.block_type) &&
                                                (statusBlock ? statusBlock[itemBlock.id]?.visible : evaluatedRulesStart[itemBlock.id]?.visible)
                                            "
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :pagePreview="true"
                                            @getAddress="handleGetAddress"
                                            :disabled="
                                                statusBlock ? statusBlock[itemBlock.id]?.disabled : evaluatedRulesStart[itemBlock.id]?.disabled
                                            "
                                            @emitBlurField="handleConditionANDOR"
                                            :settingRequireLabel="settingRequireLabel"
                                            :settingConfirmLabel="settingConfirmLabel"
                                        />
                                    </template>
                                </table>
                            </td>
                            <td v-else>
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockComplete">
                                        <CommonBlockText
                                            :key="`preview-${idx}`"
                                            v-if="[ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(itemBlock.block_type)"
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :pagePreview="true"
                                            @getAddress="handleGetAddress"
                                            :settingRequireLabel="settingRequireLabel"
                                            :settingConfirmLabel="settingConfirmLabel"
                                        />
                                    </template>
                                </table>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeI">
                            <td v-if="PAGE_TYPES._I[2] !== typePageShow">
                                <table
                                    class="fm-enquete"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <CommonBoxMail
                                        :inforData="dataPreview"
                                        :formInit="initFormPageI"
                                        :formConfig="configFormPageI"
                                        :settingDesign="dataPreview.setting_designs"
                                        :conditionPageShow="typePageShow"
                                        :isConfirmInputTwice="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.extension.confirm_input_twice"
                                    />
                                </table>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeB">
                            <td v-if="[PAGE_TYPES._B[0], PAGE_TYPES._B[4]].includes(typePageShow)">
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockSaved">
                                        <CommonOption
                                            :key="`preview-b-opt-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_RADIO,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT,
                                                    ALL_BLOCK_TYPE.BLOCK_CHECKBOX,
                                                    ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE,
                                                    ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE,
                                                    ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY
                                                ].includes(itemBlock.block_type) &&
                                                (statusBlock ? statusBlock[itemBlock.id]?.visible : evaluatedRulesStart[itemBlock.id]?.visible)
                                            "
                                            :index="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :addressInfor="inforAddress"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :pagePreview="true"
                                            @selectProvince="onHandleGetSelectProvince"
                                            @emitChange="handleConditionANDOR"
                                            :disabled="
                                                statusBlock ? statusBlock[itemBlock.id]?.disabled : evaluatedRulesStart[itemBlock.id]?.disabled
                                            "
                                            :settingRequireLabel="settingRequireLabelFormSerial"
                                        />
                                        <CommonBlockText
                                            :key="`preview-b-txt-${idx}`"
                                            v-if="
                                                [
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_1,
                                                    ALL_BLOCK_TYPE.BLOCK_DISPLAY_2,
                                                    ALL_BLOCK_TYPE.BLOCK_INPUT,
                                                    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                                                    ALL_BLOCK_TYPE.BLOCK_DATE,
                                                    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                                                    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                                                    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                                                    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                                                    ALL_BLOCK_TYPE.BLOCK_PARAMETER_ACQUISITION
                                                ].includes(itemBlock.block_type) &&
                                                (statusBlock ? statusBlock[itemBlock.id]?.visible : evaluatedRulesStart[itemBlock.id]?.visible)
                                            "
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :pagePreview="true"
                                            @getAddress="handleGetAddress"
                                            :disabled="
                                                statusBlock ? statusBlock[itemBlock.id]?.disabled : evaluatedRulesStart[itemBlock.id]?.disabled
                                            "
                                            @emitBlurField="handleConditionANDOR"
                                            :settingRequireLabel="settingRequireLabelFormSerial"
                                            :settingConfirmLabel="settingConfirmLabelFormSerial"
                                        />
                                    </template>
                                </table>
                            </td>
                            <td v-else-if="PAGE_TYPES._B[1] === typePageShow">
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockLottery">
                                        <CommonBlockText
                                            :key="`preview-lottery-${idx}`"
                                            v-if="[ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(itemBlock.block_type)"
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :pagePreview="true"
                                            @getAddress="handleGetAddress"
                                            :settingRequireLabel="settingRequireLabelFormSerial"
                                            :settingConfirmLabel="settingConfirmLabelFormSerial"
                                        />
                                    </template>
                                </table>
                                <FormBSeriaLottery
                                    :inforDataLottery="dataPreview.form_pages[PAGE_TYPES._B[1]]"
                                    :settingDesign="dataPreview.setting_designs"
                                    @skipRedirect="onHandleRedirectSkip"
                                />
                            </td>
                            <td v-else-if="PAGE_TYPES._B[3] === typePageShow">
                                <table
                                    class="fm-enquete"
                                    style="border-style: none"
                                    :cellpadding="dataPreview.setting_designs.table_settings.cell_setting.margin.value"
                                    :cellspacing="dataPreview.setting_designs.table_settings.cell_setting.spacing.value"
                                >
                                    <template v-for="(itemBlock, idx) in listBlockRejection">
                                        <CommonBlockText
                                            :key="`preview-rejection-${idx}`"
                                            v-if="[ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(itemBlock.block_type)"
                                            :index.sync="indexCommonOption"
                                            :inforBlock="itemBlock"
                                            :provinceInfor="inforProvince"
                                            :settingDesign="dataPreview.setting_designs"
                                            :configBlock="configBlockForm"
                                            :conditionPageShow="typePageShow"
                                            :pagePreview="true"
                                            @getAddress="handleGetAddress"
                                            :settingRequireLabel="settingRequireLabelFormSerial"
                                            :settingConfirmLabel="settingConfirmLabelFormSerial"
                                        />
                                    </template>
                                </table>
                            </td>
                        </template>
                    </tr>
                    <tr>
                        <template v-if="isPageTypeA && !isPageType(ID_PAGE_TYPE.C)">
                            <td class="fm-enquete-commands" style="text-align: center">
                                <div class="d-flex justify-content-center mt-5" style="gap: 12px">
                                    <div v-if="typePageShow == PAGE_TYPES._A[0]" class="btn__next" @click="handleSubmit(PAGE_TYPES._A[0])">
                                        <template v-if="settingButtonPreviewInput">
                                            <p v-if="!settingButtonPreviewInput.img_btn_register?.id" class="btn form__btn-secondary text-nowrap">
                                                {{ settingButtonPreviewInput.label_btn_register }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreviewInput.img_btn_register?.path"
                                                    :alt="settingButtonPreviewInput.img_btn_register?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="btn form__btn-secondary text-nowrap">
                                                {{ $t('managerForm.settingPage.btnSaveForm') }}
                                            </span>
                                        </template>
                                    </div>
                                    <div v-if="isPageConfirm" class="btn__back" @click="handleBackForm">
                                        <template v-if="settingButtonPreview">
                                            <p v-if="!settingButtonPreview.img_btn_back?.id" class="mb-0 btn btn-back-form">
                                                {{ settingButtonPreview.label_btn_back }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreview.img_btn_back?.path"
                                                    :alt="settingButtonPreview.img_btn_back?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p class="mb-0 btn btn-back-form">戻る</p>
                                        </template>
                                    </div>
                                    <div v-if="isPageConfirm" class="btn__confirm" @click="handleSubmit(PAGE_TYPES._A[1])">
                                        <template v-if="settingButtonPreview">
                                            <p v-if="!settingButtonPreview.img_btn_confirm?.id" class="btn form__btn-secondary">
                                                {{ settingButtonPreview.label_btn_confirm }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPreview.img_btn_confirm?.path"
                                                    :alt="settingButtonPreview.img_btn_confirm?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p class="btn form__btn-secondary">登録</p>
                                        </template>
                                    </div>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeI">
                            <td v-if="PAGE_TYPES._I[2] !== typePageShow" class="fm-enquete-commands" style="text-align: center">
                                <div class="d-flex justify-content-center mt-5" style="gap: 12px">
                                    <div v-if="typePageShow == PAGE_TYPES._I[0]" class="btn__next" @click="handleSubmit(PAGE_TYPES._I[0])">
                                        <template v-if="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons">
                                            <p
                                                v-if="!onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.img_btn_register?.id"
                                                class="btn form__btn-secondary text-nowrap"
                                            >
                                                {{ onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.label_btn_register }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.img_btn_register?.path"
                                                    :alt="onHandleGetInforPageTypeI(PAGE_TYPES._I[0])?.setting_buttons.img_btn_register?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="btn form__btn-secondary text-nowrap">
                                                {{ $t('managerForm.settingPage.btnSaveForm') }}
                                            </span>
                                        </template>
                                    </div>
                                    <template v-if="PAGE_TYPES._I[1] == typePageShow">
                                        <div class="btn__back" @click="handleBackForm">
                                            <template v-if="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons">
                                                <p
                                                    v-if="!onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_back?.id"
                                                    class="mb-0 btn btn-back-form"
                                                >
                                                    {{ onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.label_btn_back }}
                                                </p>
                                                <div v-else class="btn_frame_img">
                                                    <b-img
                                                        :src="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_back?.path"
                                                        :alt="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_back?.origin_name"
                                                    ></b-img>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="mb-0 btn btn-back-form">戻る</p>
                                            </template>
                                        </div>

                                        <div class="btn__confirm" @click="handleSubmit(PAGE_TYPES._I[1])">
                                            <template v-if="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons">
                                                <p
                                                    v-if="!onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_confirm?.id"
                                                    class="btn form__btn-secondary"
                                                >
                                                    {{ onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.label_btn_confirm }}
                                                </p>
                                                <div v-else class="btn_frame_img">
                                                    <b-img
                                                        :src="onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_confirm?.path"
                                                        :alt="
                                                            onHandleGetInforPageTypeI(PAGE_TYPES._I[1])?.setting_buttons.img_btn_confirm?.origin_name
                                                        "
                                                    ></b-img>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="btn form__btn-secondary">登録</p>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </td>
                        </template>
                        <template v-else-if="isPageTypeB">
                            <td class="fm-enquete-commands" style="text-align: center">
                                <div
                                    v-if="typePageShow == PAGE_TYPES._B[0] || typePageShow == PAGE_TYPES._B[4]"
                                    class="d-flex justify-content-center mt-5"
                                    style="gap: 12px"
                                >
                                    <div v-if="typePageShow == PAGE_TYPES._B[0]" class="btn__next" @click="handleSubmit(PAGE_TYPES._B[0])">
                                        <template v-if="settingButtonPageBInput">
                                            <p v-if="!settingButtonPageBInput.img_btn_register?.id" class="btn form__btn-secondary text-nowrap">
                                                {{ settingButtonPageBInput.label_btn_register }}
                                            </p>
                                            <div v-else class="btn_frame_img">
                                                <b-img
                                                    :src="settingButtonPageBInput.img_btn_register?.path"
                                                    :alt="settingButtonPageBInput.img_btn_register?.origin_name"
                                                ></b-img>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <span class="btn form__btn-secondary text-nowrap">
                                                {{ $t('managerForm.settingPage.btnSaveForm') }}
                                            </span>
                                        </template>
                                    </div>

                                    <template v-if="typePageShow == PAGE_TYPES._B[4]">
                                        <div class="btn__back" @click="handleBackForm">
                                            <template v-if="settingButtonPreview">
                                                <p v-if="!settingButtonPreview.img_btn_back?.id" class="mb-0 btn btn-back-form">
                                                    {{ settingButtonPreview.label_btn_back }}
                                                </p>
                                                <div v-else class="btn_frame_img">
                                                    <b-img
                                                        :src="settingButtonPreview.img_btn_back?.path"
                                                        :alt="settingButtonPreview.img_btn_back?.origin_name"
                                                    ></b-img>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="mb-0 btn btn-back-form">戻る</p>
                                            </template>
                                        </div>

                                        <div class="btn__confirm" @click="handleSubmit(PAGE_TYPES._B[4])">
                                            <template v-if="settingButtonPreview">
                                                <p v-if="!settingButtonPreview.img_btn_confirm?.id" class="btn form__btn-secondary">
                                                    {{ settingButtonPreview.label_btn_confirm }}
                                                </p>
                                                <div v-else class="btn_frame_img">
                                                    <b-img
                                                        :src="settingButtonPreview.img_btn_confirm?.path"
                                                        :alt="settingButtonPreview.img_btn_confirm?.origin_name"
                                                    ></b-img>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p class="btn form__btn-secondary">抽選する</p>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                            </td>
                        </template>
                    </tr>
                    <tr v-if="isPageTypeI">
                        <td
                            :class="`text-${onHandleGetValueTextAlign(dataPreview.setting_designs.table_settings.answer_text_alignment.horizontal)}`"
                            :style="`padding: ${
                                dataPreview.setting_designs.table_settings?.cell_setting.margin?.value
                                    ? `${dataPreview.setting_designs.table_settings?.cell_setting.margin?.value}${dataPreview.setting_designs.table_settings?.cell_setting.margin?.unit?.value}`
                                    : '30px'
                            }`"
                        >
                            <div
                                v-if="PAGE_TYPES._I[2] == typePageShow"
                                v-html="onHandleGetInforPageTypeI(PAGE_TYPES._I[2])?.extension.content"
                            ></div>
                        </td>
                    </tr>
                    <tr v-if="FOOTER">
                        <td>
                            <div class="text-center mt-5">
                                <div v-html="FOOTER"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="d-flex justify-content-center align-items-center" style="min-height: 100vh">
            <LoadingIcon />
        </div>
    </div>
</template>

<script>
import CommonOption from './components/common-option.vue';
import CommonBlockText from './components/common-text.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import CommonBoxMail from './components/common-box-mail.vue';
import FormBPrizeCode from './components/form-b/prize-code.vue';
import FormBSeriaLottery from './components/form-b/serial-lottery.vue';
import FormBSeriaRejection from './components/form-b/serial-rejection.vue';
import FormBSeriaWinning from './components/form-b/serial-winning.vue';
import {
    configBlockForm,
    handleFilterBlock,
    matchingMessageBlocks,
    onHandleMapCssForm,
    evaluateAllRules,
    onHandleGetValueTextAlign
} from './handlers';
import { validateAllField } from '@/utils/validate';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { managerFormMethods } from '@/state/helpers';
import { handleDataResponse, handleGetListSerial } from '../handlers';
import { initForm, PAGE_TYPES, ID_PAGE_TYPE } from '../constants';
import { initFormPageI, configFormPageI, handleValidateAllField } from './handleTypeI';
import { initFormPageBSerial, configFormPageBSerial } from './handleTypeB';
import { onScrollToFieldError } from '@/utils/handlers';

export default {
    name: 'IframComponent',
    components: {
        CommonOption,
        CommonBlockText,
        LoadingIcon,
        CommonBoxMail,
        FormBPrizeCode,
        FormBSeriaLottery,
        FormBSeriaRejection,
        FormBSeriaWinning
    },
    data() {
        return {
            pageType: this.$route.query.type,
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            dataPreview: initForm(),
            typePageShow: this.onHandleGetTypePageShow(),
            HEADER: '',
            FOOTER: '',
            listBlockComplete: [],
            listBlockSaved: [],
            listBlockLottery: [],
            listBlockRejection: [],
            isLoading: false,
            indexCommonOption: 0,
            settingButtonPreview: null,
            settingButtonPreviewInput: null,
            settingRequireLabel: null,
            settingConfirmLabel: null,
            settingRequireLabelFormSerial: null,
            settingConfirmLabelFormSerial: null,
            inforAddress: null,
            inforProvince: null,
            statusBlock: null,
            PAGE_TYPES,
            ID_PAGE_TYPE,
            settingButtonPageBInput: null,
            initFormPageI: initFormPageI(),
            configFormPageI: configFormPageI(),
            formSerialInit: initFormPageBSerial(),
            formSerialConfig: configFormPageBSerial()
        };
    },
    computed: {
        configBlockForm() {
            return handleFilterBlock(this.listBlockSaved, configBlockForm());
        },
        isPageComplete() {
            return this.typePageShow === PAGE_TYPES._A[2];
        },

        isPageConfirm() {
            return this.typePageShow === PAGE_TYPES._A[1];
        },
        listAllRules() {
            return this.listBlockSaved.reduce((acc, item) => {
                acc[item.id] = item.input_condition;
                return acc;
            }, {});
        },
        allModelBlock() {
            return Object.fromEntries(Object.entries(this.configBlockForm).filter(([key]) => !key.startsWith('validate')));
        },
        evaluatedRulesStart() {
            return evaluateAllRules(this.listAllRules, this.allModelBlock);
        },

        isPageTypeI() {
            return this.pageType === 'i';
        },
        isPageTypeB() {
            return this.pageType === 'b';
        },

        isPageTypeA() {
            return ['a', 'c'].includes(this.pageType);
        },

        isActiveBlockAddrMailI() {
            return this.dataPreview?.page_type?.id === ID_PAGE_TYPE.I;
        },

        isPageType() {
            return (pageType) => this.dataPreview?.page_type?.id === pageType;
        }
    },
    methods: {
        ...managerFormMethods,
        onHandleGetValueTextAlign,

        onHandleGetTypePageShow() {
            let showPage = '';
            switch (this.$route.query.type) {
                case 'a':
                    showPage = PAGE_TYPES._A[0];
                    break;
                case 'c':
                    showPage = PAGE_TYPES._C[0];
                    break;
                case 'i':
                    showPage = PAGE_TYPES._I[0];
                    break;
                case 'b':
                    showPage = PAGE_TYPES._B[0];
                    break;
            }
            return showPage;
        },

        handleBackForm() {
            window.scrollTo(0, 0);
            if ([PAGE_TYPES._A[1], PAGE_TYPES._I[1], PAGE_TYPES._B[4]].includes(this.typePageShow)) {
                this.typePageShow = this.onHandleGetTypePageShow();
            }
        },
        handleConditionANDOR() {
            let hasChanged = true;
            let iterations = 0;
            const MAX_ITERATIONS = 20;

            while (hasChanged && iterations < MAX_ITERATIONS) {
                hasChanged = false;
                iterations++;

                const results = evaluateAllRules(this.listAllRules, this.allModelBlock);
                this.statusBlock = results;

                // Clear values for hidden or disabled blocks
                for (const [id, status] of Object.entries(results)) {
                    if (status.visible === false || status.disabled === true) {
                        const cleared = this.clearBlockValue(Number(id));
                        if (cleared) {
                            hasChanged = true;
                        }
                    }
                }
            }
        },
        clearBlockValue(blockId) {
            const block = this.listBlockSaved.find((b) => b.id === blockId);
            if (!block) return false;

            const id = block.id;
            let changed = false;
            switch (block.block_type) {
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (this.configBlockForm.modelRadio[id].radio !== '' || this.configBlockForm.modelRadio[id].text !== '') {
                        this.configBlockForm.modelRadio[id] = { radio: '', text: '' };
                        if (this.configBlockForm.validateRadio[id]?.configField) {
                            this.configBlockForm.validateRadio[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_SELECT:
                    if (this.configBlockForm.modelSelect[id] !== '') {
                        this.configBlockForm.modelSelect[id] = '';
                        if (this.configBlockForm.validateSelect[id]?.configField) {
                            this.configBlockForm.validateSelect[id].configField.valueSync = null;
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    if (this.configBlockForm.modelCheckbox[id].checked.length > 0 || this.configBlockForm.modelCheckbox[id].text !== '') {
                        this.configBlockForm.modelCheckbox[id] = { checked: [], text: '' };
                        if (this.configBlockForm.validateCheckbox[id]?.configField) {
                            this.configBlockForm.validateCheckbox[id].configField.valueSync = [];
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE:
                    if (this.configBlockForm.modelProvince[id] !== '') {
                        this.configBlockForm.modelProvince[id] = '';
                        if (this.configBlockForm.validateProvince[id]?.configField) {
                            this.configBlockForm.validateProvince[id].configField.valueSync = null;
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_INPUT:
                    if (this.configBlockForm.modelInput[id] !== '' || this.configBlockForm.modelConfirmInput[id] !== '') {
                        this.configBlockForm.modelInput[id] = '';
                        this.configBlockForm.modelConfirmInput[id] = '';
                        if (this.configBlockForm.validateInput[id]?.configField) {
                            this.configBlockForm.validateInput[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                    if (this.configBlockForm.modelKeywordBox[id] !== '') {
                        this.configBlockForm.modelKeywordBox[id] = '';
                        if (this.configBlockForm.validateKeywordBox[id]?.configField) {
                            this.configBlockForm.validateKeywordBox[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
                    if (this.configBlockForm.modelTextarea[id] !== '') {
                        this.configBlockForm.modelTextarea[id] = '';
                        if (this.configBlockForm.validateTextarea[id]?.configField) {
                            this.configBlockForm.validateTextarea[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_DATE: {
                    const d = this.configBlockForm.modelDateForm[id];
                    if (
                        d.text !== '' ||
                        d.select.year?.unique_key != null ||
                        d.select.month?.unique_key != null ||
                        d.select.day?.unique_key != null
                    ) {
                        this.configBlockForm.modelDateForm[id] = {
                            text: '',
                            select: {
                                year: { unique_key: null, value: '' },
                                month: { unique_key: null, value: '' },
                                day: { unique_key: null, value: '' }
                            }
                        };
                        if (this.configBlockForm.validateDateForm[id]?.configField) {
                            this.configBlockForm.validateDateForm[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                }
                case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                    if (this.configBlockForm.modelFirstName[id] !== '' || this.configBlockForm.modelLastName[id] !== '') {
                        this.configBlockForm.modelFirstName[id] = '';
                        this.configBlockForm.modelLastName[id] = '';
                        if (this.configBlockForm.validateFirstName[id]?.configField) {
                            this.configBlockForm.validateFirstName[id].configField.valueSync = '';
                        }
                        if (this.configBlockForm.validateLastName[id]?.configField) {
                            this.configBlockForm.validateLastName[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                    if (this.configBlockForm.modelPostcode_1[id] !== '' || this.configBlockForm.modelPostcode_2[id] !== '') {
                        this.configBlockForm.modelPostcode_1[id] = '';
                        this.configBlockForm.modelPostcode_2[id] = '';
                        if (this.configBlockForm.validatePostcode_1[id]?.configField) {
                            this.configBlockForm.validatePostcode_1[id].configField.valueSync = '';
                        }
                        if (this.configBlockForm.validatePostcode_2[id]?.configField) {
                            this.configBlockForm.validatePostcode_2[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    if (
                        this.configBlockForm.modelInputPhone_1[id] !== '' ||
                        this.configBlockForm.modelInputPhone_2[id] !== '' ||
                        this.configBlockForm.modelInputPhone_3[id] !== ''
                    ) {
                        this.configBlockForm.modelInputPhone_1[id] = '';
                        this.configBlockForm.modelInputPhone_2[id] = '';
                        this.configBlockForm.modelInputPhone_3[id] = '';
                        if (this.configBlockForm.validateInputPhone_1[id]?.configField) {
                            this.configBlockForm.validateInputPhone_1[id].configField.valueSync = '';
                        }
                        if (this.configBlockForm.validateInputPhone_2[id]?.configField) {
                            this.configBlockForm.validateInputPhone_2[id].configField.valueSync = '';
                        }
                        if (this.configBlockForm.validateInputPhone_3[id]?.configField) {
                            this.configBlockForm.validateInputPhone_3[id].configField.valueSync = '';
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                    if (this.configBlockForm.modelUploadFile[id] !== null) {
                        this.configBlockForm.modelUploadFile[id] = null;
                        if (this.configBlockForm.validateUploadFile[id]?.configField) {
                            this.configBlockForm.validateUploadFile[id].configField.valueSync = null;
                        }
                        changed = true;
                    }
                    break;
                case ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY:
                    if (this.configBlockForm.modelRemainingBox[id] !== null) {
                        this.configBlockForm.modelRemainingBox[id] = null;
                        if (this.configBlockForm.validateRemainingBox[id]?.configField) {
                            this.configBlockForm.validateRemainingBox[id].configField.valueSync = null;
                        }
                        changed = true;
                    }
                    break;
            }
            return changed;
        },
        checkFormValid(form) {
            let isValid = true;
            Object.keys(form).forEach((key) => {
                const field = form[key];
                if (key.startsWith('configField')) {
                    if (field.error && !field.isAddressNotFoundError) {
                        isValid = false;
                    }
                }

                if (Array.isArray(field)) {
                    field.forEach((item) => {
                        if (typeof item === 'object' && item !== null) {
                            isValid = this.checkFormValid(item) && isValid;
                        }
                    });
                } else if (typeof field === 'object' && field !== null) {
                    isValid = this.checkFormValid(field) && isValid;
                }
            });

            return isValid;
        },
        suppressHiddenErrors(form, statusBlock) {
            for (const [modelKey, modelValue] of Object.entries(form)) {
                if (!modelKey.startsWith('validate')) continue;

                for (const [id, field] of Object.entries(modelValue)) {
                    const status = statusBlock[id];
                    // Nếu visible=false hoặc disabled=true, xóa lỗi
                    if (status && (status.visible === false || status.disabled === true)) {
                        if (field.configField) {
                            field.configField.error = false;
                            field.configField.errorField = '';
                        }
                        if (field.configFieldText) {
                            field.configFieldText.error = false;
                            field.configFieldText.errorField = '';
                        }
                    }
                }
            }
        },

        async handleSubmit(typeSubmit) {
            if (typeSubmit == PAGE_TYPES._A[0]) {
                this.indexCommonOption = this.indexCommonOption > 100 ? 0 : this.indexCommonOption + 1;
                this.$nextTick(() => {
                    onScrollToFieldError('form__alert--error');
                });
                const statusBlockComputed = this.statusBlock ? this.statusBlock : this.evaluatedRulesStart;

                validateAllField(this.configBlockForm);
                matchingMessageBlocks(this.configBlockForm, this.listBlockSaved);
                this.suppressHiddenErrors(this.configBlockForm, statusBlockComputed);

                let checkField = this.checkFormValid(this.configBlockForm);

                if (!checkField) {
                    this.isLoading = false;
                    onScrollToFieldError();
                    return;
                }
                window.scrollTo(0, 0);
                this.typePageShow = PAGE_TYPES._A[1];
            } else if (typeSubmit == PAGE_TYPES._A[1]) {
                this.typePageShow = PAGE_TYPES._A[2];
            } else if (typeSubmit == PAGE_TYPES._I[0]) {
                let checkValidTypeI = handleValidateAllField(this.initFormPageI, this.configFormPageI, this.dataPreview);
                if (!checkValidTypeI) return;
                window.scrollTo(0, 0);
                this.typePageShow = PAGE_TYPES._I[1];
            } else if (typeSubmit == PAGE_TYPES._I[1]) {
                this.typePageShow = PAGE_TYPES._I[2];
            } else if (typeSubmit == PAGE_TYPES._B[0]) {
                this.indexCommonOption = this.indexCommonOption > 100 ? 0 : this.indexCommonOption + 1;
                this.$nextTick(() => {
                    onScrollToFieldError('form__alert--error');
                });
                const statusBlockComputed = this.statusBlock ? this.statusBlock : this.evaluatedRulesStart;

                validateAllField(this.configBlockForm);
                matchingMessageBlocks(this.configBlockForm, this.listBlockSaved);
                this.suppressHiddenErrors(this.configBlockForm, statusBlockComputed);

                let checkField = this.checkFormValid(this.configBlockForm);
                // Also validate the prize selection if prize-before-draw is enabled
                if (this.dataPreview.setting_lottery.is_prize_before_the_draw) {
                    if (!this.formSerialInit.serial_prize) {
                        this.formSerialConfig.serial_prize.error = true;
                        this.formSerialConfig.serial_prize.errorField = '必ず選択してください。';
                        checkField = false;
                    }
                }
                if (!checkField) return;

                // Extract serial code block value
                const serialBlock = this.listBlockSaved.find((b) => b.is_serial_code_type_b);
                if (serialBlock) {
                    this.formSerialInit.serial_code = this.configBlockForm.modelInput[serialBlock.id] || '';
                }
                if (this.formSerialInit.serial_code.toString()) {
                    const errorSerial = await handleGetListSerial(
                        { ...this, formData: this.dataPreview },
                        { query: `/lookup?serial_code=${this.formSerialInit.serial_code}` }
                    );
                    if (!errorSerial?.exists) {
                        this.configBlockForm.validateInput[serialBlock.id].configField.error = true;
                        this.configBlockForm.validateInput[serialBlock.id].configField.errorField =
                            serialBlock.additional_setting.error_message_block.find(
                                (item) => item.type_msg === 'no_suitable_data_to_input'
                            )?.messages;
                        this.indexCommonOption = this.indexCommonOption > 100 ? 0 : this.indexCommonOption + 1;
                        return false;
                    }
                } else {
                    this.configBlockForm.validateInput[serialBlock.id].configField.error = true;
                    this.configBlockForm.validateInput[serialBlock.id].configField.errorField = '必ず入力してください。';
                    this.indexCommonOption = this.indexCommonOption > 100 ? 0 : this.indexCommonOption + 1;
                    return false;
                }
                window.scrollTo(0, 0);
                this.typePageShow = PAGE_TYPES._B[4];
            } else if (typeSubmit == PAGE_TYPES._B[4]) {
                window.scrollTo(0, 0);
                this.typePageShow = PAGE_TYPES._B[1];
            }
        },

        onHandleRedirectSkip() {
            if (this.formSerialInit.serial_prize === '') {
                this.typePageShow = PAGE_TYPES._B[3];
            } else {
                this.typePageShow = PAGE_TYPES._B[2];
            }
            window.scrollTo(0, 0);
        },

        inforButtonPageConfirm(newDataPreview) {
            this.settingButtonPreview = newDataPreview.form_pages.page_confirms?.setting_buttons;
            this.settingButtonPreviewInput = newDataPreview.form_pages.page_inputs?.setting_buttons;
            this.settingRequireLabel = newDataPreview.form_pages.page_inputs?.setting_requires;
            this.settingConfirmLabel = newDataPreview.form_pages.page_inputs?.setting_confirms;
            this.settingButtonPageBInput = newDataPreview.form_pages.page_input_serial_code?.setting_buttons;
            this.settingRequireLabelFormSerial = newDataPreview.form_pages.page_input_serial_code?.setting_requires;
            this.settingConfirmLabelFormSerial = newDataPreview.form_pages.page_input_serial_code?.setting_confirms;
        },

        handleGetAddress(address) {
            this.inforAddress = address;
        },

        onHandleGetSelectProvince(provinceValue) {
            this.inforProvince = provinceValue;
        },

        async getDetailPreviewForm() {
            if (!this.$route?.query?.id) return;
            this.isLoading = true;
            try {
                const response = await this.getDetailManagerForm(this.$route.query.id);
                this.dataPreview = handleDataResponse(this.dataPreview, response);
                let getPageChildrenInput = [];
                let getPageChildrenComplete = [];
                let getPageChildrenB0 = [];
                let getPageChildrenLottery = [];
                let getPageChildrenRejection = [];
                this.dataPreview.setting_page.pages.forEach((page) => {
                    page.page_child.forEach((pageChild) => {
                        switch (pageChild.type_page_wl) {
                            case PAGE_TYPES._A[0]:
                                getPageChildrenInput = pageChild.blocks;
                                break;
                            case PAGE_TYPES._B[0]:
                                getPageChildrenB0 = pageChild.blocks;
                                break;
                            case PAGE_TYPES._A[2]:
                                getPageChildrenComplete = pageChild.blocks;
                                break;
                            case PAGE_TYPES._B[1]:
                                getPageChildrenLottery = pageChild.blocks;
                                break;
                            case PAGE_TYPES._B[3]:
                                getPageChildrenRejection = pageChild.blocks;
                                break;
                        }
                    });
                });
                if (this.isPageTypeB) {
                    this.listBlockSaved = getPageChildrenB0;
                } else {
                    this.listBlockSaved = getPageChildrenInput;
                }
                this.listBlockComplete = getPageChildrenComplete;
                this.listBlockLottery = getPageChildrenLottery;
                this.listBlockRejection = getPageChildrenRejection;
                this.HEADER = this.dataPreview?.header ? this.dataPreview?.header : '';
                this.FOOTER = this.dataPreview?.footer ? this.dataPreview?.footer : '';
                this.inforButtonPageConfirm(response);
                onHandleMapCssForm(this.dataPreview.setting_designs);
                window.document.title = this.dataPreview?.setting_designs?.title ?? '';
                if (this.dataPreview?.serial_code_prizes?.length <= 0 || !this.dataPreview?.setting_lottery.is_prize_before_the_draw) {
                    this.formSerialConfig.serial_prize.typesValidate = [];
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        onHandleGetInforPageTypeI(typeI) {
            return this.dataPreview.form_pages[typeI];
        }
    },
    mounted() {
        this.getDetailPreviewForm();
    }
};
</script>
